import { computed, reactive, watch } from "vue";
import { useWindowSize } from "@vueuse/core";

let store = reactive({
  sessions: [],
  showAdvanced: false,
  showingAllBinsPreference: true,
  selectedBinIndex: 0,
  selectedTableKey: "binStatus",
  showingRelativeValues: true,
  toast: null
});

export default store;
globalThis.store = store;

let { width: windowWidth } = useWindowSize();
export let showingDesktopUi = computed(() => windowWidth.value >= 1000 || window.chrome?.webview);
export let showingAllBins = computed(() => showingDesktopUi.value ? true : store.showingAllBinsPreference);

watch(showingDesktopUi, () => {
  if (showingDesktopUi.value) {
    document.body.classList.add('desktop');
    document.body.classList.remove('mobile');
  }
  else {
    document.body.classList.add('mobile');
    document.body.classList.remove('desktop');
  }
}, { immediate: true });

export let bins = computed(() => {
  return store.sessions[0].system.bins.children;
});

export let selectedBin = computed({
  get: () => bins.value[store.selectedBinIndex],
  set: (value) => store.selectedBinIndex = bins.value.findIndex(bin => bin == value)
});

window.addEventListener("keydown", (event) => {
  if (event.key == "F6") {
    event.preventDefault();
    store.showAdvanced = !store.showAdvanced;
    return false;
  }
});